/* Harucake Theme JS */

(function () {
  'use strict';

  /* ─────────────────────────────────────────
     CALENDAR
     ───────────────────────────────────────── */
  const OPEN_DAYS = [2, 3, 4, 5, 6]; // Tue-Sat (0=Sun)
  const MAX_DAYS_AHEAD = 30;
  const MIN_DAYS_AHEAD = 2; // at least 2 days notice

  // -- Standard cake one-off reopen dates ------------------------------------
  const STANDARD_FORCE_OPEN_DATES = new Set(['2026-11-03','2026-11-04','2026-11-05','2026-11-06','2026-11-07']);

  const TIMESLOTS = {
    weekday: ['12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM'],
    weekend: ['12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM']
  };

  const PICKUP_SLOT_DISPLAY_BY_DATE = {};

  /* ── TEMPORARY (Sat 2026-10-10 only, ALL calendar products): 12:00 PM + 1:00 PM pickup slots are closed for NEW
     orders with that PICKUP DATE. Uses the existing shared "Full" mechanism: the slot renders disabled with a "Full"
     label (never silently re-selected), the PDP submit backstop rejects it, and the cart checkout guard rejects a cart
     line that still carries it. Every other slot and every other date is untouched. SAFE TO DELETE after 2026-10-10 —
     it also self-expires with the date. */
  const FULL_SLOTS_BY_DATE = {
    '2026-10-10': ['12:00 PM', '1:00 PM']
  };

  function isSlotFullOnDate(ymd, slot) {
    return !!(FULL_SLOTS_BY_DATE[ymd] && FULL_SLOTS_BY_DATE[ymd].indexOf(slot) !== -1);
  }

  const STANDARD_FULL_SLOTS_BY_DATE = {};

  function isStandardSlotFullOnDate(ymd, slot) {
    return !!(STANDARD_FULL_SLOTS_BY_DATE[ymd] && STANDARD_FULL_SLOTS_BY_DATE[ymd].indexOf(slot) !== -1);
  }

  /* ── TEMPORARY (Sat 2026-10-03 only, pre-order ASSORTED CAKE only — CYO + Let Harucake Choose share this product) ──
     Too many early pickups are already booked for that Saturday, so 1:00 PM and 2:00 PM are closed for NEW Assorted
     pre-orders with that PICKUP DATE. Customers keep the product's existing later slots (3:00–6:00 PM) — nothing new is
     invented. Storefront-only: existing orders, other whole cakes, Same Day products, Live Inventory, the dashboard
     availability record, lettering and every other date are untouched. Gated by BOTH product (isAssortedCakeProduct /
     cart handle) AND pickup date. Enforced in three places: slot rendering (hidden), PDP submit (stale DOM/state
     backstop) and the cart checkout guard. SAFE TO DELETE after Sat 2026-10-03 — it also self-expires with the date. */
  const ASSORTED_BLOCKED_SLOTS_BY_DATE = { '2026-10-03': ['1:00 PM', '2:00 PM'] };
  const ASSORTED_BLOCKED_SLOT_MSG = 'That pickup time is no longer available for Assorted Cake on this date. Please choose a later pickup time.';
  function isAssortedSlotBlockedOnDate(ymd, slot) {
    return !!(ASSORTED_BLOCKED_SLOTS_BY_DATE[ymd] && ASSORTED_BLOCKED_SLOTS_BY_DATE[ymd].indexOf(String(slot || '').trim()) !== -1);
  }

  // Assorted/CYO minimum pickup times by weekday:
//   Tue–Fri: 12:00 PM
//   Sat: 1:00 PM
// Sun/Mon stay closed via the existing OPEN_DAYS guard.
  const ASSORTED_CAKE_MIN_MINUTES_WEEKDAY = 720; // 12:00 PM
  const ASSORTED_CAKE_MIN_MINUTES_SAT     = 780; // 1:00 PM

  function assortedMinMinutesForDate(date) {
    return (date && typeof date.getDay === 'function' && date.getDay() === 6)
      ? ASSORTED_CAKE_MIN_MINUTES_SAT
      : ASSORTED_CAKE_MIN_MINUTES_WEEKDAY;
}

  function timeToMinutes(slot) {
    const m = String(slot).trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
    if (!m) return 0;
    let h = parseInt(m[1], 10);
    const min = parseInt(m[2], 10);
    const mer = m[3].toUpperCase();
    if (mer === 'PM' && h !== 12) h += 12;
    if (mer === 'AM' && h === 12) h = 0;
    return h * 60 + min;
  }

  function isAssortedCakeProduct() {
    const form = document.getElementById('product-form');
    if (!form) return false;
    const handle = (form.dataset.productHandle || '').toLowerCase();
    const title  = (form.dataset.productTitle  || '').toLowerCase();
    return handle.includes('assorted') || title.includes('assorted cake');
  }

  function filterSlotsForAssorted(slots, date) {
    if (!isAssortedCakeProduct()) return slots;
    const minMinutes = assortedMinMinutesForDate(date);
    return slots.filter(function(slot) {
      return timeToMinutes(slot) >= minMinutes && !isAssortedSlotBlockedOnDate(formatYMD(date), slot);
    });
  }

  function isSameDayProduct(form) {
    if (!form) return false;
    const handle = (form.dataset.productHandle || '').toLowerCase();
    const title = (form.dataset.productTitle || '').toLowerCase();
    const sameDayFlag = String(form.dataset.sameDay || '').toLowerCase();
    const path = window.location.pathname.toLowerCase();
    return (
      sameDayFlag === 'true' ||
      handle.indexOf('same-day') !== -1 ||
      handle.indexOf('sameday') !== -1 ||
      title.indexOf('same day') !== -1 ||
      path.indexOf('/products/same-day') !== -1 ||
      path.indexOf('/products/sameday') !== -1
    );
  }

  function getTodayYMDInLosAngeles() {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    const year = parts.find(function(p) { return p.type === 'year'; }).value;
    const month = parts.find(function(p) { return p.type === 'month'; }).value;
    const day = parts.find(function(p) { return p.type === 'day'; }).value;
    return year + '-' + month + '-' + day;
  }

  function setLineItemProperty(form, name, value) {
    if (!form) return;
    const inputName = 'properties[' + name + ']';
    let input = form.querySelector('input[name="' + inputName + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      form.appendChild(input);
    }
    input.value = value;
  }

  function prepareSameDayPickup(form) {
    if (!form) return;
    setLineItemProperty(form, 'Pickup Date', getTodayYMDInLosAngeles());
    setLineItemProperty(form, 'Pickup Time', 'Same-day pickup, earliest 1:00 PM. Please allow 1\u20132 hours after ordering.');   // customer-visible (cart / checkout / emails); keep in sync with sections/main-product.liquid
    setLineItemProperty(form, 'Order Type', 'Same-Day Pickup');
  }

  // "Today" for every pickup-date rule is the LOS ANGELES calendar date (built as a local Date at midnight so
  // it compares cleanly with the calendar's local Date cells). Previously this was the customer's browser-local
  // date, so a customer in another timezone could see a date open/close a day early or late.
  function getToday() {
    const p = getTodayYMDInLosAngeles().split('-');
    const d = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function addDays(date, n) {
    const d = new Date(date);
    d.setDate(d.getDate() + n);
    return d;
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() &&
           a.getMonth() === b.getMonth() &&
           a.getDate() === b.getDate();
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function formatYMD(d) {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function parseDisplayDate(value) {
    if (!value) return null;
    const parsed = new Date(value);
    if (isNaN(parsed.getTime())) return null;
    parsed.setHours(0, 0, 0, 0);
    return parsed;
  }

  // Parse a date string like "Mon, May 25, 2026" robustly (no timezone ambiguity)
  function parseEditDateString(str) {
    if (!str) return null;
    var MONTHS = {jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11};
    var m = str.match(/([A-Za-z]+)\s+(\d{1,2}),?\s+(\d{4})/);
    if (!m) return null;
    var mo = MONTHS[m[1].toLowerCase().substring(0, 3)];
    if (mo === undefined) return null;
    var d = new Date(parseInt(m[3], 10), mo, parseInt(m[2], 10));
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function getBlackoutDates() {
    const source = document.getElementById('pickup-blackout-dates');
    const dates = new Set();
    if (!source) return dates;
    source.textContent
      .split(/\r?\n/)
      .map(function(v) { return v.trim(); })
      .filter(Boolean)
      .forEach(function(v) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(v)) dates.add(v);
      });
    return dates;
  }

  // The rule set the page was loaded with. Every pickup-date decision (calendar cells, add-to-cart, checkout)
  // goes through isSelectable() with a rule set; by default the one baked into this file.
  function currentPickupRules() {
    return { openDays: OPEN_DAYS.slice(), minDaysAhead: MIN_DAYS_AHEAD, maxDaysAhead: MAX_DAYS_AHEAD, forceOpen: new Set(STANDARD_FORCE_OPEN_DATES), closedDates: new Set(PAGE_PREORDER_CLOSED_DATES), source: 'page' };
  }

  // ABSOLUTE RULE for the pre-order (calendar) flow — standard "Our Cakes", Assorted/CYO pre-orders, small bakes:
  // a pickup date that is TODAY (Los Angeles) or in the PAST is never valid. It is evaluated FIRST, before any
  // force-open logic, so a forgotten STANDARD_FORCE_OPEN_DATES entry becomes harmless the moment that date is
  // today. Legitimate same-day products (tag `same-day` → form[data-same-day] → isSameDayProduct) never go
  // through isSelectable(): they have no calendar and prepareSameDayPickup() sets Pickup Date = today.
  function isPreorderDateHardBlocked(d, today) {
    return !(d > (today || getToday()));   // today or earlier → blocked; only strictly-future dates continue
  }

  // rules (optional): { openDays, minDaysAhead, maxDaysAhead } — defaults to the constants above. forceOpenDates
  // stays an explicit argument because same-day products pass an empty Set on purpose.
  function isSelectable(d, blackoutDates, forceOpenDates, rules) {
    if (!blackoutDates) blackoutDates = new Set();
    if (!forceOpenDates) forceOpenDates = new Set();
    const r = rules || currentPickupRules();
    const today = getToday();
    if (isPreorderDateHardBlocked(d, today)) return false;   // ← hard stop: force-open is never consulted for today/past
    const earliest = addDays(today, r.minDaysAhead);
    const latest = addDays(today, r.maxDaysAhead);
    const ymd = formatYMD(d);
    if (r.closedDates && r.closedDates.has(ymd)) return false;   // owner dashboard closed THIS cake for that date (new pre-orders only) — force-open never reopens it
    const isForceOpenDate = forceOpenDates.has(ymd);
    return (
      d >= today &&
      d <= latest &&
      (isForceOpenDate || d >= earliest) &&
      (r.openDays.includes(d.getDay()) || isForceOpenDate) &&
      (isForceOpenDate || !blackoutDates.has(ymd))
    );
  }

  /* ─────────────────────────────────────────
     LIVE PICKUP RULES (stale-tab / stale-cart protection)
     ─────────────────────────────────────────
     The rule constants above are baked into this file when a page loads. A tab left open (or a cart filled)
     before STANDARD_FORCE_OPEN_DATES / blackout dates changed still holds the OLD rules. Before an add-to-cart
     and before checkout we therefore re-read the CURRENT rules from the server:
       1. fetch the product page HTML (no-store)  → current theme.js URL (Shopify versions asset URLs, so a
          changed file has a new URL) + the product's current #pickup-blackout-dates list (settings + any
          product-specific dates, e.g. the Mango cutoff);
       2. if that theme.js URL differs from the one this page loaded → fetch it (no-store) and read
          OPEN_DAYS / MIN_DAYS_AHEAD / MAX_DAYS_AHEAD / STANDARD_FORCE_OPEN_DATES out of it;
       3. evaluate the date with isSelectable() against THOSE rules — same function as the calendar.
     No date logic is duplicated: only the inputs are refreshed. */
  const PICKUP_DATE_UNAVAILABLE_MSG = 'This pickup date is no longer available. Please select another pickup date.';

  function loadedThemeJsSrc() {
    const el = document.querySelector('script[src*="theme.js"]');
    return el ? el.getAttribute('src') : '';
  }
  function themeJsSrcFromHtml(html) {
    const m = String(html).match(/<script[^>]+src=["']([^"']*\/theme\.js[^"']*)["']/i);
    return m ? m[1] : '';
  }
  function blackoutDatesFromHtml(html) {
    const dates = new Set();
    const m = String(html).match(/<script[^>]*id=["']pickup-blackout-dates["'][^>]*>([\s\S]*?)<\/script>/i);
    if (!m) return dates;
    m[1].split(/\r?\n/).map(function(v) { return v.trim(); }).forEach(function(v) { if (/^\d{4}-\d{2}-\d{2}$/.test(v)) dates.add(v); });
    return dates;
  }
  // Read the four rule constants from a theme.js source text. Shopify serves theme assets MINIFIED
  // (e.g. `const OPEN_DAYS=[2,3,4,5,6],MAX_DAYS_AHEAD=30,MIN_DAYS_AHEAD=2,STANDARD_FORCE_OPEN_DATES=new Set(["2026-09-11"])`),
  // so the patterns key on the identifier only, not on `const`. Returns null when any of them cannot be read —
  // the caller then treats the rules as unknown: the cart blocks, the product page reloads (a reloaded page
  // runs the current constants, no parsing needed).
  function pickupRulesFromThemeJs(text) {
    const src = String(text);
    const open = src.match(/\bOPEN_DAYS\s*=\s*\[([^\]]*)\]/);
    const min = src.match(/\bMIN_DAYS_AHEAD\s*=\s*(\d+)/);
    const max = src.match(/\bMAX_DAYS_AHEAD\s*=\s*(\d+)/);
    const force = src.match(/\bSTANDARD_FORCE_OPEN_DATES\s*=\s*new Set\(\[([^\]]*)\]\)/);
    if (!open || !min || !max || !force) return null;
    const openDays = open[1].split(',').map(function(v) { return parseInt(v, 10); }).filter(function(v) { return !isNaN(v); });
    const forceOpen = new Set((force[1].match(/\d{4}-\d{2}-\d{2}/g) || []));
    return { openDays: openDays, minDaysAhead: parseInt(min[1], 10), maxDaysAhead: parseInt(max[1], 10), forceOpen: forceOpen, source: 'live' };
  }
  // Resolve { rules, blackout, stale } for a product page URL. Rejects on network/parse failure.
  function fetchLivePickupRules(productPageUrl) {
    const url = productPageUrl || (window.location.pathname + window.location.search);
    return fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function(r) { if (!r.ok) throw new Error('page ' + r.status); return r.text(); })
      .then(function(html) {
        const blackout = blackoutDatesFromHtml(html);
        const liveSrc = themeJsSrcFromHtml(html);
        const mySrc = loadedThemeJsSrc();
        if (!liveSrc) throw new Error('theme.js not found in page');
        if (liveSrc === mySrc) return { rules: currentPickupRules(), blackout: blackout, stale: false };
        return fetch(liveSrc, { cache: 'no-store' })
          .then(function(r) { if (!r.ok) throw new Error('theme.js ' + r.status); return r.text(); })
          .then(function(js) {
            const rules = pickupRulesFromThemeJs(js);
            if (!rules) throw new Error('rules unreadable');
            return { rules: rules, blackout: blackout, stale: true };
          });
      });
  }
  // One cart line item → { ok, reason } under a given rule set. Items without a Pickup Date (candles, add-ons,
  // accessories) are not cakes and are always ok. Same-day cakes are valid only for today (LA).
  function validateCartItemPickup(item, live, avail) {
    const props = (item && item.properties) || {};
    const rawDate = props['Pickup Date'];
    if (!rawDate) return { ok: true, reason: 'no-pickup-date' };
    const handle = String(item.handle || '').toLowerCase();
    const isSameDayItem = String(props['Order Type'] || '') === 'Same-Day Pickup' || handle.indexOf('same-day') !== -1 || handle.indexOf('sameday') !== -1;
    if (isSameDayItem) {
      const ymd = /^\d{4}-\d{2}-\d{2}$/.test(String(rawDate).trim()) ? String(rawDate).trim() : (parseEditDateString(rawDate) ? formatYMD(parseEditDateString(rawDate)) : '');
      if (ymd !== getTodayYMDInLosAngeles()) return { ok: false, reason: 'same-day-not-today' };
      if (sameDayLetteringInCart(props) && sameDayLetteringClosedOn(avail || preorderAvailabilityData(), ymd)) return { ok: false, reason: 'same-day-lettering' };
      return { ok: true };
    }
    const date = /^\d{4}-\d{2}-\d{2}$/.test(String(rawDate).trim()) ? (function(v) { const p = v.split('-'); const d = new Date(+p[0], +p[1] - 1, +p[2]); d.setHours(0, 0, 0, 0); return d; })(String(rawDate).trim()) : parseEditDateString(rawDate);
    if (!date) return { ok: false, reason: 'unreadable-date' };
    if (!isSelectable(date, live.blackout, live.rules.forceOpen, live.rules)) return { ok: false, reason: 'date' };
    var closedWhy = preorderClosedReason(avail || preorderAvailabilityData(), handle, formatYMD(date));
    if (closedWhy) return { ok: false, reason: closedWhy };
    if (props['Pickup Time'] && dashboardSlotClosedOn(avail || preorderAvailabilityData(), formatYMD(date), props['Pickup Time'])) return { ok: false, reason: 'pickup-time-closed' };
    if (props['Pickup Time'] && isSlotFullOnDate(formatYMD(date), String(props['Pickup Time']).trim())) return { ok: false, reason: 'time-full' };
    if (handle.indexOf('assorted') !== -1 && props['Pickup Time']) {
      if (timeToMinutes(props['Pickup Time']) < assortedMinMinutesForDate(date)) return { ok: false, reason: 'assorted-time' };
      if (isAssortedSlotBlockedOnDate(formatYMD(date), props['Pickup Time'])) return { ok: false, reason: 'assorted-time' };
    }
    return { ok: true };
  }
  /* ─────────────────────────────────────────
     PREORDER AVAILABILITY (owner dashboard → storefront) — NEW pre-orders only
     harucake-board keeps a per-pickup-date record the owner edits on /preorder-availability:
       { letteringDisabled: bool, disabledHandles: ['banana-chocolate', …], disabledFlavors: ['Banana Chocolate', …] }
     Storefront contract (SUBTRACT-ONLY):
       • no record for a date            → the hardcoded rules in this file apply unchanged
       • letteringDisabled               → that pickup date joins LETTERING_DISABLED_DATES (pre-order products only)
       • handle in disabledHandles       → that pickup date is closed on THAT cake's calendar / submit / cart guard
       • disabledFlavors                 → consumed by snippets/cyo-block.liquid (Assorted Choose Your Own)
       • preordersDisabled               → "Close all preorders": that pickup date is closed on EVERY pre-order product
                                            (regular whole cakes + Assorted, CYO and Let Harucake Choose) — explicit field
       • assortedDisabled                → the pre-order Assorted Cake (CYO + LHYC) is closed for that date — explicit field,
                                            never inferred from disabledFlavors (all flavors closed ≠ Assorted closed)
     A dashboard record can only CLOSE; it never reopens a hardcoded restriction and never touches Same Day products
     (same-day pages never call this), inventory, production or existing orders.
     FAIL-OPEN: fetched once per PDP load (shared through window.HaruPreorderAvailability), 3 s timeout, any error →
     `ok:false` with no overrides, i.e. exactly today's behaviour. The board marks orders placed against a restriction
     for staff review, so a failed fetch can never silently lose a rule.
     ───────────────────────────────────────── */
  const PREORDER_AVAILABILITY_API = 'https://harucake-board-production.up.railway.app/api/preorder-availability';
  const PREORDER_AVAILABILITY_TIMEOUT_MS = 3000;
  const PREORDER_AVAILABILITY_DAYS = 31;   // today → today+31 covers MAX_DAYS_AHEAD (30)
  const PREORDER_LETTERING_TITLE = 'Lettering Temporarily Unavailable';
  const PREORDER_LETTERING_MSG = 'Lettering is unavailable for orders on this pickup date. Thank you for your understanding.';
  const PREORDER_CLOSED_CART_MSG = 'This cake is no longer available for the selected pickup date. Please remove it or tap Edit to choose a new pickup date.';
  const PREORDERS_CLOSED_TITLE = 'Preorders Unavailable';
  const PREORDERS_CLOSED_MSG = 'We are not accepting preorders for this pickup date. Thank you for your understanding.';
  const ASSORTED_CLOSED_TITLE = 'Assorted Cake Unavailable';
  const ASSORTED_CLOSED_MSG = 'Assorted Cake is not available for this pickup date. Thank you for your understanding.';
  const PREORDERS_CLOSED_CART_MSG = PREORDERS_CLOSED_MSG + ' Please remove this cake or tap Edit to choose a new pickup date.';
  const ASSORTED_CLOSED_CART_MSG = ASSORTED_CLOSED_MSG + ' Please remove it or tap Edit to choose a new pickup date.';
  const SAME_DAY_LETTERING_CLOSED_MSG = 'Same-day board lettering is no longer available today.';
  const SAME_DAY_LETTERING_CART_MSG = SAME_DAY_LETTERING_CLOSED_MSG + ' Please remove this cake and add it again without lettering.';
  const NO_PICKUP_TIMES_MSG = 'No pickup times are available for this pickup date. Please choose another date.';
  const PICKUP_TIME_CLOSED_MSG = 'The pickup time you selected is no longer available for this date. Please choose another pickup time.';
  const PICKUP_TIME_UNCONFIRMED_MSG = 'We can\u2019t confirm pickup availability right now. Please try again in a moment.';
  const PICKUP_TIME_CLOSED_CART_MSG = 'The selected pickup time is no longer available for this pickup date. Please tap Edit to choose another pickup time.';
  const SAME_DAY_LETTERING_UNCONFIRMED_MSG = 'We can’t confirm same-day lettering availability right now. Please try again in a moment, or switch Board Writing off to order your cake without lettering.';
  /* LAST-KNOWN-GOOD (LKG) fallback — the dashboard is the only source of temporary pre-order restrictions, so a board
     outage / slow cold start / malformed body must not silently reopen closed dates. Every successful fetch is stored in
     localStorage (PREORDER_LKG_KEY: { fetchedAt, from, to, payload }). On ANY failure the stored payload is applied instead
     when it is younger than PREORDER_LKG_MAX_AGE_MS (48 h); otherwise the page falls back to the rules in this file
     (fail-open) and logs a console warning. Per-browser only; the board's review flag stays the operational backstop.
     Same Day pages never call this (they never fetch), and no inventory / production code reads the storefront cache. */
  const PREORDER_LKG_KEY = 'haru_poa_lkg';
  const PREORDER_LKG_MAX_AGE_MS = 48 * 60 * 60 * 1000;
  function preorderLkgRead() {
    try {
      if (typeof localStorage === 'undefined') return null;
      var raw = localStorage.getItem(PREORDER_LKG_KEY); if (!raw) return null;
      var rec = JSON.parse(raw);
      if (!rec || typeof rec !== 'object' || !rec.payload || typeof rec.payload !== 'object' || !isFinite(rec.fetchedAt)) return null;
      return rec;
    } catch (e) { return null; }
  }
  function preorderLkgWrite(payload, from, to) {
    try { if (typeof localStorage !== 'undefined') localStorage.setItem(PREORDER_LKG_KEY, JSON.stringify({ fetchedAt: Date.now(), from: from, to: to, payload: payload })); } catch (e) {}
  }
  /* SHOPIFY METAFIELD SNAPSHOT — fallback #2. The board writes shop.metafields.harucake.preorder_availability (type json)
     after every owner change; sections/main-product.liquid renders it into #preorder-availability-snapshot on PRE-ORDER
     product pages only (inside `unless is_same_day`), so a brand-new browser still gets the rules when the board is down.
     Precedence per PDP load: 1 live API (valid payload) → 2 this snapshot → 3 localStorage LKG (< 48 h) → 4 none.
     The snapshot is validated field by field and can only SUBTRACT (same evaluators as the API payload). The LKG is
     never refreshed from the snapshot (its fetchedAt means "last live API success"). Same Day pages never call this. */
  const PREORDER_SNAPSHOT_ID = 'preorder-availability-snapshot';
  const PREORDER_SNAPSHOT_VERSION = 1;
  function preorderSlug(name) { return String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  // Strict shape check → API-shaped payload (with derived disabledHandles) or null. Never throws.
  function preorderSnapshotToPayload(raw) {
    try {
      if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return null;
      if (raw.version !== PREORDER_SNAPSHOT_VERSION || raw.scope !== 'new-preorders-only') return null;
      if (!raw.overrides || typeof raw.overrides !== 'object' || Array.isArray(raw.overrides)) return null;
      var overrides = {};
      var keys = Object.keys(raw.overrides);
      for (var i = 0; i < keys.length; i++) {
        var ymd = keys[i]; var o = raw.overrides[ymd];
        if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd) || !o || typeof o !== 'object' || Array.isArray(o)) return null;
        var flags = ['preordersDisabled', 'assortedDisabled', 'letteringDisabled', 'sameDayLetteringDisabled'];
        for (var f = 0; f < flags.length; f++) { if (o[flags[f]] !== undefined && typeof o[flags[f]] !== 'boolean') return null; }
        if (o.disabledFlavors !== undefined && !Array.isArray(o.disabledFlavors)) return null;
        if (o.disabledPickupTimes !== undefined && !Array.isArray(o.disabledPickupTimes)) return null;
        var times = [];
        (o.disabledPickupTimes || []).forEach(function(t) { if (typeof t === 'string' && t.trim()) times.push(t.trim()); });
        var flavors = [];
        (o.disabledFlavors || []).forEach(function(n) { if (typeof n === 'string' && n.trim()) flavors.push(n.trim()); });
        overrides[ymd] = { preordersDisabled: o.preordersDisabled === true, assortedDisabled: o.assortedDisabled === true, letteringDisabled: o.letteringDisabled === true, sameDayLetteringDisabled: o.sameDayLetteringDisabled === true, disabledFlavors: flavors, disabledPickupTimes: times, disabledHandles: flavors.map(preorderSlug) };
      }
      return { scope: 'new-preorders-only', from: String(raw.from || ''), to: String(raw.to || ''), generatedAt: String(raw.generatedAt || ''), overrides: overrides };
    } catch (e) { return null; }
  }
  function preorderSnapshotRead() {
    try {
      if (typeof document === 'undefined' || !document.getElementById) return null;
      var el = document.getElementById(PREORDER_SNAPSHOT_ID); if (!el) return null;
      var txt = String(el.textContent || '').trim(); if (!txt || txt === 'null') return null;
      return preorderSnapshotToPayload(JSON.parse(txt));
    } catch (e) { return null; }
  }
  // Failure path: metafield snapshot → LKG if fresh → empty (hardcoded rules only). Always logs the source in devtools.
  function preorderAvailabilityFallback(reason) {
    var snap = preorderSnapshotRead();
    if (snap) {
      var outS = parsePreorderAvailability(snap);
      outS.source = 'metafield'; outS.reason = String(reason || ''); outS.generatedAt = snap.generatedAt;
      if (typeof console !== 'undefined' && console.warn) console.warn('[preorder-availability] live fetch failed (' + outS.reason + ') — using the Shopify metafield snapshot from ' + (snap.generatedAt || 'unknown time'));
      return outS;
    }
    var rec = preorderLkgRead();
    var age = rec ? (Date.now() - Number(rec.fetchedAt)) : Infinity;
    if (rec && age >= 0 && age <= PREORDER_LKG_MAX_AGE_MS) {
      var out = parsePreorderAvailability(rec.payload);
      out.source = 'lkg'; out.reason = String(reason || ''); out.fetchedAt = Number(rec.fetchedAt);
      if (typeof console !== 'undefined' && console.warn) console.warn('[preorder-availability] live fetch failed (' + out.reason + ') — using last-known-good from ' + new Date(out.fetchedAt).toISOString());
      return out;
    }
    if (typeof console !== 'undefined' && console.warn) console.warn('[preorder-availability] live fetch failed (' + String(reason || '') + '), no valid metafield snapshot and no recent last-known-good — permanent rules only');
    var empty = emptyPreorderAvailability(reason); empty.source = 'none'; return empty;
  }
  let PAGE_PREORDER_CLOSED_DATES = new Set();   // filled by initProductPage() for the cake on THIS page (pre-order products only)
  function emptyPreorderAvailability(reason) { return { ok: false, reason: String(reason || ''), overrides: {} }; }
  function parsePreorderAvailability(data) {
    var out = { ok: true, reason: '', overrides: {} };
    var ov = data && data.overrides;
    if (!ov || typeof ov !== 'object') return out;
    Object.keys(ov).forEach(function(ymd) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return;
      var o = ov[ymd] || {};
      out.overrides[ymd] = {
        preordersDisabled: !!o.preordersDisabled,
        assortedDisabled: !!o.assortedDisabled,
        letteringDisabled: !!o.letteringDisabled,
        sameDayLetteringDisabled: !!o.sameDayLetteringDisabled,   // SAME DAY products only (owner switch, 2026-10-15)
        disabledPickupTimes: (Array.isArray(o.disabledPickupTimes) ? o.disabledPickupTimes : []).map(function(t) { return String(t).trim(); }),   // pre-order slot strings, e.g. '12:00 PM'
        disabledHandles: (Array.isArray(o.disabledHandles) ? o.disabledHandles : []).map(function(h) { return String(h).toLowerCase(); }),
        disabledFlavors: (Array.isArray(o.disabledFlavors) ? o.disabledFlavors : []).map(String)
      };
    });
    return out;
  }
  function fetchPreorderAvailability() {
    var shared = window.HaruPreorderAvailability;
    if (shared && shared.promise) return shared.promise;
    var p = new Promise(function(resolve) {
      var done = false;
      var finish = function(res) { if (done) return; done = true; if (timer && typeof clearTimeout === 'function') clearTimeout(timer); resolve(res); };
      var ctrl = (typeof AbortController === 'function') ? new AbortController() : null;
      var timer = setTimeout(function() { if (ctrl) { try { ctrl.abort(); } catch (e) {} } finish(preorderAvailabilityFallback('timeout')); }, PREORDER_AVAILABILITY_TIMEOUT_MS);
      try {
        var from = formatYMD(getToday());
        var to = formatYMD(addDays(getToday(), PREORDER_AVAILABILITY_DAYS));
        var url = PREORDER_AVAILABILITY_API + '?from=' + from + '&to=' + to + (PREORDER_FRESH_BUST ? '&_=' + Date.now() : '');
        fetch(url, ctrl ? { cache: 'no-store', signal: ctrl.signal } : { cache: 'no-store' })
          .then(function(r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
          .then(function(data) {
            // only a well-formed payload (scope + overrides object) counts as "good" — anything else is a failure
            if (!data || typeof data !== 'object' || !data.overrides || typeof data.overrides !== 'object' || data.scope !== 'new-preorders-only') throw new Error('malformed');
            preorderLkgWrite(data, from, to);
            var res = parsePreorderAvailability(data); res.source = 'live'; finish(res);
          })
          .catch(function(err) { finish(preorderAvailabilityFallback(err && err.message || err)); });
      } catch (err) { finish(preorderAvailabilityFallback(err && err.message || err)); }
    });
    window.HaruPreorderAvailability = { promise: p, data: null, api: PREORDER_AVAILABILITY_API };
    p.then(function(res) { window.HaruPreorderAvailability.data = res; });
    return p;
  }
  // FRESH re-check (submit-time / checkout-click): drops the per-page shared promise so the CURRENT record is read; the
  // result becomes the new shared data. Same timeout + fallback chain, never rejects. Callers that must not reopen on a
  // fallback result check `source === 'live'` (see applySameDayDashboardResult).
  // The public API answers with Cache-Control max-age=60; `cache: 'no-store'` only bypasses THIS browser's cache, so a
  // fresh confirmation also adds a cache-busting query parameter to get past any intermediate cache.
  var PREORDER_FRESH_BUST = false;
  function fetchPreorderAvailabilityFresh() {
    window.HaruPreorderAvailability = null;
    PREORDER_FRESH_BUST = true;
    try { return fetchPreorderAvailability(); } finally { PREORDER_FRESH_BUST = false; }
  }
  function preorderAvailabilityData() { return (window.HaruPreorderAvailability && window.HaruPreorderAvailability.data) || null; }
  function preorderOverrideFor(avail, ymd) { return (avail && avail.ok && avail.overrides && avail.overrides[ymd]) || null; }
  function preorderLetteringClosedOn(avail, ymd) { var o = preorderOverrideFor(avail, ymd); return !!(o && o.letteringDisabled); }
  // Owner switch "Same-Day Cake Lettering: Unavailable" for the LA date a same-day order is placed on. Independent of
  // letteringDisabled (pre-orders). Read by same-day product pages and the cart guard only.
  function sameDayLetteringClosedOn(avail, ymd) { var o = preorderOverrideFor(avail, ymd); return !!(o && o.sameDayLetteringDisabled); }
  // Owner dashboard "Pickup Time Availability": slot closed to NEW pre-orders on that pickup date (every pre-order
  // product). Subtract-only — consumed through isTimeFullForCurrentProduct() so every existing slot rule still applies.
  function dashboardSlotClosedOn(avail, ymd, slot) {
    var o = preorderOverrideFor(avail, ymd);
    return !!(o && Array.isArray(o.disabledPickupTimes) && o.disabledPickupTimes.indexOf(String(slot || '').trim()) !== -1);
  }
  function sameDayLetteringInCart(props) {
    return /yes/i.test(String(props['Writing Requested'] || '')) || !!String(props['Cake Writing'] || '').trim() || !!String(props['Board Message'] || '').trim();
  }
  function preorderHandleClosedOn(avail, handle, ymd) {
    var o = preorderOverrideFor(avail, ymd);
    var h = String(handle || '').toLowerCase();
    return !!(o && h && o.disabledHandles.indexOf(h) !== -1);
  }
  function isAssortedHandle(handle) { return String(handle || '').toLowerCase().indexOf('assorted') !== -1; }
  // Why a pre-order product is closed on a date: 'preorders-closed' (whole date) | 'assorted-closed' (Assorted only) |
  // 'preorder-closed' (this whole-cake flavor) | null. Evaluated in that order; subtract-only; same-day handles never asked.
  function preorderClosedReason(avail, handle, ymd) {
    var o = preorderOverrideFor(avail, ymd);
    if (!o) return null;
    if (o.preordersDisabled) return 'preorders-closed';
    if (isAssortedHandle(handle)) return o.assortedDisabled ? 'assorted-closed' : null;
    return preorderHandleClosedOn(avail, handle, ymd) ? 'preorder-closed' : null;
  }
  function preorderClosedMessage(reason) {
    return reason === 'preorders-closed' ? PREORDERS_CLOSED_MSG : reason === 'assorted-closed' ? ASSORTED_CLOSED_MSG : PICKUP_DATE_UNAVAILABLE_MSG;
  }
  function preorderClosedDatesForHandle(avail, handle) {
    var out = new Set();
    if (!avail || !avail.ok) return out;
    Object.keys(avail.overrides).forEach(function(ymd) { if (preorderClosedReason(avail, handle, ymd)) out.add(ymd); });
    return out;
  }
  window.HaruPickupRules = { current: currentPickupRules, isSelectable: isSelectable, isPreorderDateHardBlocked: isPreorderDateHardBlocked, fetchLive: fetchLivePickupRules, parseThemeJs: pickupRulesFromThemeJs, blackoutFromHtml: blackoutDatesFromHtml, validateCartItem: validateCartItemPickup, MESSAGE: PICKUP_DATE_UNAVAILABLE_MSG, preorderAvailability: fetchPreorderAvailability, preorderHandleClosedOn: preorderHandleClosedOn, preorderClosedReason: preorderClosedReason, preorderLetteringClosedOn: preorderLetteringClosedOn, preorderLkgKey: PREORDER_LKG_KEY, preorderSnapshotToPayload: preorderSnapshotToPayload };

  const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  window.HaruCalendar = {
    selectedDate: null,
    viewYear: null,
    viewMonth: null,
    blackoutDates: new Set(),
    forceOpenDates: new Set(),
    wrap: null,

    init: function(wrapSelector, options) {
      if (!options) options = {};
      this.wrap = document.querySelector(wrapSelector);
      if (!this.wrap) return;
      this.blackoutDates = options.blackoutDates || new Set();
      this.forceOpenDates = options.forceOpenDates || new Set();
      const today = getToday();
      this.viewYear = today.getFullYear();
      this.viewMonth = today.getMonth();
      const self = this;
      this.wrap.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-cal-nav]');
        if (btn) {
          const dir = parseInt(btn.dataset.calNav, 10);
          self.viewMonth += dir;
          if (self.viewMonth > 11) { self.viewMonth = 0; self.viewYear++; }
          if (self.viewMonth < 0) { self.viewMonth = 11; self.viewYear--; }
          self.render();
          return;
        }
        const day = e.target.closest('[data-cal-date]');
        if (day && !day.classList.contains('cal-day--unavailable')) {
          self.selectedDate = new Date(parseInt(day.dataset.calDate, 10));
          self.selectedDate.setHours(0, 0, 0, 0);
          self.render();
          self.onSelect(self.selectedDate);
        }
      });
      this.render();
    },

    render: function() {
      if (this.selectedDate && !isSelectable(this.selectedDate, this.blackoutDates, this.forceOpenDates)) {
        this.selectedDate = null;
        this.onClear();
      }
      const today = getToday();
      const earliest = addDays(today, MIN_DAYS_AHEAD);
      const latest = addDays(today, MAX_DAYS_AHEAD);
      const firstOfMonth = new Date(this.viewYear, this.viewMonth, 1);
      const lastOfMonth  = new Date(this.viewYear, this.viewMonth + 1, 0);
      const prevDisabled = lastOfMonth < earliest;
      const nextDisabled = firstOfMonth > latest;
      let html = '<div class="cal-header">' +
        '<button class="cal-nav" data-cal-nav="-1"' + (prevDisabled ? ' disabled' : '') + '>&#8592;</button>' +
        '<span class="cal-title">' + MONTH_NAMES[this.viewMonth] + ' ' + this.viewYear + '</span>' +
        '<button class="cal-nav" data-cal-nav="1"' + (nextDisabled ? ' disabled' : '') + '>&#8594;</button>' +
        '</div><div class="cal-grid">' +
        '<div class="cal-dow">Su</div><div class="cal-dow">Mo</div><div class="cal-dow">Tu</div>' +
        '<div class="cal-dow">We</div><div class="cal-dow">Th</div><div class="cal-dow">Fr</div>' +
        '<div class="cal-dow">Sa</div>';
      const firstDay = new Date(this.viewYear, this.viewMonth, 1).getDay();
      const daysInMonth = new Date(this.viewYear, this.viewMonth + 1, 0).getDate();
      const self = this;
      for (let i = 0; i < firstDay; i++) {
        html += '<div class="cal-day cal-day--empty"></div>';
      }
      for (let d = 1; d <= daysInMonth; d++) {
        const date = new Date(self.viewYear, self.viewMonth, d);
        date.setHours(0, 0, 0, 0);
        const selectable = isSelectable(date, self.blackoutDates, self.forceOpenDates);
        const selected = self.selectedDate && sameDay(date, self.selectedDate);
        const cls = 'cal-day' +
          (!selectable ? ' cal-day--unavailable' : '') +
          (selected ? ' cal-day--selected' : '');
        html += '<div class="' + cls + '"' +
          (selectable ? ' data-cal-date="' + date.getTime() + '"' : '') +
          '>' + d + '</div>';
      }
      html += '</div>';
      this.wrap.innerHTML = html;
    },

    onSelect: function(date) {},
    onClear: function() {}
  };

  /* ─────────────────────────────────────────
     SAME-DAY LETTERING CUTOFF
     ───────────────────────────────────────── */
  // -- TEMPORARY: dates on which same-day writing is fully unavailable --------
  // Add 'YYYY-MM-DD' strings (LA time) to disable same-day board lettering
  // for that day only. REMOVE the entry the next day to restore normal flow.
  // The 2:00 PM same-day cutoff below still applies on any day NOT listed here.
  const SAME_DAY_WRITING_DISABLED_DATES = new Set([
    '2026-05-29' // Fri 2026-05-29: lettering staff leaving early — remove tomorrow
  ]);
  // Same-day lettering closed Mon 2026-09-28 → Wed 2026-10-14 (inclusive). This is the SAME-DAY half of the former
  // all-products lettering closure; the PRE-ORDER half now lives in the owner's Preorder Availability record (dashboard)
  // and is applied through fetchPreorderAvailability(). Local-date string stepping, no UTC math. SAFE TO DELETE after 2026-10-14.
  (function addSameDayLetteringClosure(start, end) {
    var p = start.split('-'); var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    for (var i = 0; i < 366; i++) { var ymd = formatYMD(d); if (ymd > end) break; SAME_DAY_WRITING_DISABLED_DATES.add(ymd); d.setDate(d.getDate() + 1); }
  })('2026-09-28', '2026-10-14');
  // Owner dashboard switch for TODAY (LA) — set from fetchPreorderAvailability() results on same-day pages. Joins the
  // hardcoded dates below through isSameDayWritingDisabledToday(), so every existing consumer (initial grey-out,
  // otherLetteringDisableActive, the submit sanitizer) applies it; the 2 PM cutoff stays OR-ed in everywhere.
  let DASHBOARD_SAME_DAY_LETTERING_CLOSED = false;
  // Only a LIVE answer may reopen (source 'live'); a fallback answer (metafield / LKG / none) can only close — stale
  // fallback data never overrides a restriction this page already knows about.
  function applySameDayDashboardResult(avail) {
    var closedNow = sameDayLetteringClosedOn(avail, getTodayYMDInLosAngeles());
    DASHBOARD_SAME_DAY_LETTERING_CLOSED = (avail && avail.source === 'live') ? closedNow : (DASHBOARD_SAME_DAY_LETTERING_CLOSED || closedNow);
    return DASHBOARD_SAME_DAY_LETTERING_CLOSED;
  }
  function isSameDayWritingDisabledToday() {
    return SAME_DAY_WRITING_DISABLED_DATES.has(getTodayYMDInLosAngeles()) || DASHBOARD_SAME_DAY_LETTERING_CLOSED;
  }

  function isAfterLetteringCutoff() {
    var laHour = parseInt(new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      hour12: false
    }).format(new Date()), 10);
    return laHour >= 14;
  }

  /* ─────────────────────────────────────────
     PRODUCT PAGE
     ───────────────────────────────────────── */
  function initProductPage() {
    const form = document.getElementById('product-form');
    if (!form) return;

    let blackoutDates = getBlackoutDates();   // refreshed by the live pickup check when the server's list changed
    const sizeCards = document.querySelectorAll('.size-card');
    const sizeInput = document.getElementById('size-input');
    const priceDisplay = document.getElementById('hc-selected-price');
    const variantInput = document.getElementById('variant-id');
    let selectedSize = sizeCards[0] ? sizeCards[0].dataset.size : null;
    let writingEnabled = false;
    let qty = 1;
    function getActiveCard() { return document.querySelector('.size-card--active'); }
    function getBasePrice() {
      var card = getActiveCard();
      if (!card) return 0;
      return parseFloat((writingEnabled ? card.dataset.yesPrice : card.dataset.noPrice) || 0);
    }
    function calcTotal() { return getBasePrice() * qty; }
    function updatePrice() { if (priceDisplay) priceDisplay.textContent = '$' + calcTotal().toFixed(2); }
    function updateVariant() {
      var card = getActiveCard();
      if (!card || !variantInput) return;
      var vid = writingEnabled ? card.dataset.yesVariantId : card.dataset.noVariantId;
      if (vid) variantInput.value = vid;
      var writingFlag = document.getElementById('writing-flag');
      if (writingFlag) writingFlag.value = writingEnabled ? 'Yes (+$10)' : 'No';
    }
    sizeCards.forEach(function(card) {
      card.addEventListener('click', function() {
        sizeCards.forEach(function(c) { c.classList.remove('size-card--active'); });
        card.classList.add('size-card--active');
        selectedSize = card.dataset.size;
        if (sizeInput) sizeInput.value = selectedSize;
        updateVariant();
        updatePrice();
      });
    });
    if (sizeCards[0]) { sizeCards[0].classList.add('size-card--active'); if (sizeInput) sizeInput.value = selectedSize; }
    const writingToggle = document.getElementById('writing-toggle');
    const writingField  = document.getElementById('writing-field');
    const writingInput  = document.getElementById('writing-text');
    if (writingToggle) {
      writingToggle.addEventListener('change', function() {
        writingEnabled = writingToggle.checked;
        if (writingField) { writingField.style.display = writingEnabled ? 'block' : 'none'; }
        updateVariant();
        updatePrice();
      });
    }
    if (writingInput) {
      writingInput.addEventListener('input', function() {
        const counter = document.getElementById('char-count');
        if (counter) counter.textContent = writingInput.value.length;
      });
    }
    const isSameDay = isSameDayProduct(form);
    // Same-day board lettering: grey-out at/after 2 PM LA time — keep visible but disabled.
    // Also grey-out for any date listed in SAME_DAY_WRITING_DISABLED_DATES (temporary today-only block).
    const SAME_DAY_CUTOFF_MSG_ID = 'same-day-lettering-cutoff-msg';
    // Idempotent: runs at init (synchronous, unchanged behaviour) and again after the owner dashboard answers / the
    // submit-time fresh check. Only ever DISABLES — nothing here re-enables lettering once it has been greyed out.
    function applySameDayLetteringCutoff() {
      if (!(isSameDay && writingToggle)) return false;
      if (!(isAfterLetteringCutoff() || isSameDayWritingDisabledToday())) return false;
      var letteringSection = writingToggle.closest('.option-section') || writingToggle.parentNode;
      if (letteringSection) {
        letteringSection.style.opacity = '0.45';
        letteringSection.style.pointerEvents = 'none';
      }
      writingToggle.disabled = true;
      writingToggle.checked = false;
      writingEnabled = false;
      var cutoffMsg = document.getElementById(SAME_DAY_CUTOFF_MSG_ID);
      if (!cutoffMsg) {
        cutoffMsg = document.createElement('p');
        cutoffMsg.id = SAME_DAY_CUTOFF_MSG_ID;
        cutoffMsg.style.cssText = 'font-size:13px;color:#8e2525;background:#fdf4f4;border:1px solid #f0d0d0;border-radius:6px;padding:8px 14px;margin-bottom:16px;line-height:1.5;letter-spacing:.01em;';
        if (letteringSection && letteringSection.parentNode) {
          letteringSection.parentNode.insertBefore(cutoffMsg, letteringSection);
        }
      }
      cutoffMsg.textContent = isSameDayWritingDisabledToday()
        ? 'Same-day writing is unavailable today.'
        : 'Same-day board lettering is available until 2:00 PM only.';
      return true;
    }
    applySameDayLetteringCutoff();
    // Owner dashboard: "Same-Day Cake Lettering: Unavailable" for today (LA). One fetch per page load through the
    // shared chain (live → metafield snapshot → LKG → none); on a closed answer the existing disable path runs and any
    // lettering the customer already toggled is sanitized (normalizeLetteringOff → No variant / price / flag).
    if (isSameDay && writingToggle) {
      fetchPreorderAvailability().then(function(avail) {
        applySameDayDashboardResult(avail);
        if (isSameDayWritingDisabledToday()) { normalizeLetteringOff(); applySameDayLetteringCutoff(); }
      });
    }

    /* ── TEMPORARY (Sat 2026-08-22 only): lettering unavailable for that pickup date ──
       Covers pre-order whole cakes, Assorted/CYO, and same-day cakes ordered that day.
       Storefront-only, date-specific (NOT a generic Saturday rule). Remove after Aug 22
       or just leave it — the calendar cannot select a past date, so it self-expires. */
    /* ── TEMPORARY (Fri 2026-09-25, and Fri 2026-10-02 + Sat 2026-10-03): NO cake lettering for those PICKUP dates ──
       Production-capacity restriction, keyed by the customer's selected pickup date (same-day = today, LA).
       Date-specific ONLY (not a recurring Fri/Sat rule). Rides the Aug-22 mechanism below unchanged.
       SAFE TO DELETE this block (and the .concat) after Sat 2026-10-03 — it also self-expires once those
       dates can no longer be selected. */
    const TEMPORARY_NO_LETTERING_DATES = ['2026-09-25', '2026-10-02', '2026-10-03'];
    const TEMPORARY_NO_LETTERING_MSG = 'We\u2019re unable to offer cake lettering for pickups on Friday, September 25. Thank you so much for your understanding!';
    const TEMPORARY_NO_LETTERING_OCT_DATES = ['2026-10-02', '2026-10-03'];
    const TEMPORARY_NO_LETTERING_OCT_MSG = 'We\u2019re unable to offer cake lettering for pickups on Friday, October 2 and Saturday, October 3. Thank you so much for your understanding!';
    const LETTERING_DISABLED_DATES = new Set(['2026-08-22'].concat(TEMPORARY_NO_LETTERING_DATES));
    const AUG22_LETTERING_MSG_ID = 'lettering-date-unavailable-msg';
    /* Temporary PRE-ORDER lettering closures (e.g. the former Sep 28 → Oct 14 closure) are no longer hardcoded here:
       the owner sets them per pickup date on the dashboard (Preorder Availability Controls) and they arrive through
       fetchPreorderAvailability() → DASHBOARD_LETTERING_DATES below. Same-day lettering keeps its own permanent
       mechanism (SAME_DAY_WRITING_DISABLED_DATES + the 2 PM cutoff). */
    // Owner dashboard (Preorder Availability Controls): dates whose record says letteringDisabled are ADDED to
    // LETTERING_DISABLED_DATES once the shared fetch resolves (pre-order products only — never same-day). A date the
    // hardcoded rules above already close keeps its hardcoded wording; a dashboard-only date shows PREORDER_LETTERING_*.
    const HARDCODED_LETTERING_DATES = new Set(LETTERING_DISABLED_DATES);
    const DASHBOARD_LETTERING_DATES = new Set();
    function isDashboardOnlyLetteringDate(ymd) { return !!ymd && DASHBOARD_LETTERING_DATES.has(ymd) && !HARDCODED_LETTERING_DATES.has(ymd); }
    function letteringDateMessage(ymd) {
      if (isDashboardOnlyLetteringDate(ymd)) return PREORDER_LETTERING_MSG;
      if (TEMPORARY_NO_LETTERING_OCT_DATES.indexOf(ymd) !== -1) return TEMPORARY_NO_LETTERING_OCT_MSG;
      return TEMPORARY_NO_LETTERING_DATES.indexOf(ymd) !== -1 ? TEMPORARY_NO_LETTERING_MSG : 'Lettering is unavailable for this pickup date.';
    }
    /* ── TEMPORARY (Sat 2026-09-26 only): 7-inch cakes ONLY for that PICKUP date ──
       Date-specific ONLY (not a recurring Saturday / next-day rule). While that date is selected the 6" size card is
       disabled (button disabled + aria-disabled + greyed), an active 6" is switched to 7" through the normal card click
       path (so selectedSize / size-input / variant-id / price / lettering variant stay in sync), and a notice is shown
       under the size selector. Changing away restores 6" (no switch back). No-op when there is no 6" card (Assorted,
       7"-only products, same-day products). The add-to-cart backstop beside the May-26 rule is the hard gate.
       SAFE TO DELETE after Sat 2026-09-26 — it also self-expires once that date can no longer be selected. */
    const SEVEN_INCH_ONLY_DATES = ['2026-09-26'];
    const SEVEN_INCH_ONLY_MSG = 'For Saturday, September 26 pickup, only 7-inch cakes are available.';
    const SEVEN_INCH_ONLY_MSG_ID = 'size-date-unavailable-msg';
    function sizeCardFor(inch) {
      for (var i = 0; i < sizeCards.length; i++) { if (String(sizeCards[i].dataset.size || '').replace(/[^0-9]/g, '') === inch) return sizeCards[i]; }
      return null;
    }
    /* ── STANDING RULE: next-day pickup = 7" only (calendar-day based) ──
       When a pickup date exactly ONE Los Angeles calendar day ahead is selectable (normally only through
       STANDARD_FORCE_OPEN_DATES or a lowered MIN_DAYS_AHEAD), the cake layers are already prepared, so only the
       product's EXISTING 7" option may be ordered: allowed sizes = product sizes ∩ {7"}. Every other size card is
       disabled (same greyed pattern as the Sep-26 rule), an active non-7" selection is CLEARED (size-input and
       variant-id emptied — never silently switched or submitted), and a short notice is shown under the size cards.
       2+ days out everything is restored. No-op when the product has no size cards (Assorted / same-day). The
       add-to-cart backstop beside the Sep-26 one is the hard gate for stale DOM/state. Same-day products never
       reach this code (no calendar, no size cards). */
    const NEXT_DAY_SIZE_MSG = 'Next-day pickup is available in 7" only.';
    function isNextDayPickupYMD(ymd) { return !!ymd && ymd === formatYMD(addDays(getToday(), 1)); }
    function sizeInchOf(size) { return String(size || '').replace(/[^0-9]/g, ''); }
    function clearSizeSelection() {
      sizeCards.forEach(function(c) { c.classList.remove('size-card--active'); });
      selectedSize = null;
      if (sizeInput) sizeInput.value = '';
      if (variantInput) variantInput.value = '';
      updatePrice();
    }
    function applySizeDateRule(selectedDate) {
      if (!sizeCards.length) return;
      var ymd = selectedDate ? formatYMD(selectedDate) : '';
      var nextDay = isNextDayPickupYMD(ymd);
      var sep26 = !!(ymd && SEVEN_INCH_ONLY_DATES.indexOf(ymd) !== -1);
      var host = document.getElementById('size-cards') || sizeCards[0].parentNode;
      var msg = document.getElementById(SEVEN_INCH_ONLY_MSG_ID);
      var anyBlocked = false;
      sizeCards.forEach(function(card) {
        var inch = sizeInchOf(card.dataset.size);
        var blocked = (nextDay && inch !== '7') || (sep26 && inch === '6');
        if (blocked) {
          anyBlocked = true;
          if (card.classList.contains('size-card--active')) {
            if (nextDay) { clearSizeSelection(); }
            else { var card7 = sizeCardFor('7'); if (card7 && !card7.disabled) card7.click(); }   // Sep-26 behaviour unchanged
          }
          card.disabled = true; card.setAttribute('aria-disabled', 'true'); card.style.opacity = '0.45'; card.style.pointerEvents = 'none';
        } else {
          card.disabled = false; card.removeAttribute('aria-disabled'); card.style.opacity = ''; card.style.pointerEvents = '';
        }
      });
      if (anyBlocked) {
        if (!msg && host) {
          msg = document.createElement('p'); msg.id = SEVEN_INCH_ONLY_MSG_ID; msg.setAttribute('role', 'status');
          msg.style.cssText = 'margin-top:8px;font-size:13px;line-height:1.4;color:#b42318;';
          host.insertAdjacentElement('afterend', msg);
        }
        if (msg) msg.textContent = nextDay ? NEXT_DAY_SIZE_MSG : SEVEN_INCH_ONLY_MSG;
      } else if (msg && msg.parentNode) {
        msg.parentNode.removeChild(msg);
      }
    }
    // True when lettering is already legitimately disabled for a DIFFERENT reason
    // (same-day >=2 PM cutoff or the same-day today-block) — so we never fight it.
    function otherLetteringDisableActive() {
      return isSameDay && (isAfterLetteringCutoff() || isSameDayWritingDisabledToday());
    }
    // Force lettering OFF and drive the EXISTING per-product variant sync (no hardcoded IDs):
    // dispatching 'change' on #writing-toggle re-runs theme.js updateVariant (whole cake),
    // the cyo-block listener (Assorted/CYO), and any same-day listener → each picks its own "No" variant.
    function normalizeLetteringOff() {
      if (writingToggle) writingToggle.checked = false;
      writingEnabled = false;
      if (writingInput) {
        writingInput.value = '';
        var cc = document.getElementById('char-count');
        if (cc) cc.textContent = '0';
      }
      if (writingField) writingField.style.display = 'none';
      var wf = document.getElementById('writing-flag');
      if (wf) wf.value = 'No';
      if (writingToggle) writingToggle.dispatchEvent(new Event('change'));
    }
    // Apply/clear the Aug-22 rule based on the effective pickup date for THIS product:
    // same-day uses today (LA); calendar products use the selected calendar date.
    function applyLetteringDateRule(selectedDate) {
      if (!writingToggle) return;
      var ymd = isSameDay
        ? getTodayYMDInLosAngeles()
        : (selectedDate ? formatYMD(selectedDate) : null);
      var section = writingToggle.closest('.option-section') || writingToggle.parentNode;
      var blocked = !!(ymd && LETTERING_DISABLED_DATES.has(ymd));
      if (blocked) {
        normalizeLetteringOff();
        writingToggle.disabled = true;
        if (section) { section.style.opacity = '0.45'; section.style.pointerEvents = 'none'; }
        // Show ONE message only; don't stack on top of an existing same-day cutoff notice.
        if (!otherLetteringDisableActive() && section && section.parentNode) {
          var msg = document.getElementById(AUG22_LETTERING_MSG_ID);
          if (!msg) {
            msg = document.createElement('p');
            msg.id = AUG22_LETTERING_MSG_ID;
            msg.style.cssText = 'font-size:13px;color:#8e2525;background:#fdf4f4;border:1px solid #f0d0d0;border-radius:6px;padding:8px 14px;margin-bottom:16px;line-height:1.5;letter-spacing:.01em;';
            section.parentNode.insertBefore(msg, section);
          }
          if (isDashboardOnlyLetteringDate(ymd)) {
            msg.innerHTML = '<strong>' + PREORDER_LETTERING_TITLE + '</strong><br>' + PREORDER_LETTERING_MSG;
          } else {
            msg.textContent = letteringDateMessage(ymd); // date-specific wording (Sep 25/26 uses the customer notice)
          }
        }
      } else {
        var existing = document.getElementById(AUG22_LETTERING_MSG_ID);
        if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
        // Only re-enable if no OTHER legitimate disable condition is active (e.g. same-day >=2 PM cutoff).
        if (!otherLetteringDisableActive()) {
          writingToggle.disabled = false;
          if (section) { section.style.opacity = ''; section.style.pointerEvents = ''; }
        }
      }
    }
    // Init pass: same-day products have no calendar (pickup date = today), so evaluate now.
    // Calendar products re-evaluate on each date selection (cal.onSelect) and edit-mode prefill.
    applyLetteringDateRule(null);
    applySizeDateRule(null);

    /* ── TEMPORARY (2026-09-04 only, SAME-DAY only): Insulated Cake Bag add-on unavailable ──
       Only 2 bags physically left in store for same-day pickup today; don't let same-day
       customers oversell them. Shopify inventory is NOT touched — future dates sell normally.
       Same-day pickup date = today (LA). Pre-order calendar can't reach today (min lead time),
       so no calendar handling is needed. Remove this block (or the date) to revert. */
    var INSULATED_BAG_DISABLED_DATES = ['2026-09-04'];
    var insulatedBagBlockedToday = isSameDay && INSULATED_BAG_DISABLED_DATES.indexOf(getTodayYMDInLosAngeles()) !== -1;
    function normalizeInsulatedBagOff() {
      var cards = document.querySelectorAll('.cake-addon-card, .cake-addon-modal-card');
      for (var i = 0; i < cards.length; i++) {
        var n = cards[i].querySelector('.cake-addon-name');
        if (!n || n.textContent.trim() !== 'Insulated Cake Bag') continue;
        var chk = cards[i].querySelector('.cake-addon-check, .cake-addon-modal-check');
        if (chk) chk.checked = false;
      }
    }
    if (insulatedBagBlockedToday) {
      var bagCards = document.querySelectorAll('.cake-addon-card, .cake-addon-modal-card');
      for (var bi = 0; bi < bagCards.length; bi++) {
        var bc = bagCards[bi];
        var bn = bc.querySelector('.cake-addon-name');
        if (!bn || bn.textContent.trim() !== 'Insulated Cake Bag') continue;
        var bchk = bc.querySelector('.cake-addon-check, .cake-addon-modal-check');
        if (bchk) { bchk.checked = false; bchk.disabled = true; }
        if (bc.classList.contains('cake-addon-modal-card')) { bc.style.display = 'none'; continue; }
        bc.style.opacity = '0.5';
        bc.style.pointerEvents = 'none';
        bc.setAttribute('aria-disabled', 'true');
        if (!bc.querySelector('.cake-addon-datemsg')) {
          var bm = document.createElement('span');
          bm.className = 'cake-addon-datemsg';
          bm.textContent = 'Sold out for same-day pickup today';
          bm.style.cssText = 'flex:1 1 100%;margin-top:6px;font-size:12px;font-weight:600;color:#8e2525;';
          bc.appendChild(bm);
        }
      }
    }

    const qtyDisplay = document.getElementById('qty-display');
    const qtyMinus   = document.getElementById('qty-minus');
    const qtyPlus    = document.getElementById('qty-plus');
    const qtyInput   = document.getElementById('qty-input');
    function updateQty(val) {
      qty = Math.max(1, val);
      if (qtyDisplay) qtyDisplay.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      updatePrice();
    }
    if (qtyMinus) { qtyMinus.addEventListener('click', function() { updateQty(qty - 1); }); }
    if (qtyPlus)  { qtyPlus.addEventListener('click',  function() { updateQty(qty + 1); }); }
    const dateInput       = document.getElementById('date-input');
    const dateDisplay     = document.getElementById('selected-date-display');
    const timeInput       = document.getElementById('time-input');
    const timeslotWrap    = document.getElementById('timeslot-wrap');
    const timeslotSection = document.getElementById('timeslot-section');
    const productForceOpenDates = !isSameDay ? STANDARD_FORCE_OPEN_DATES : new Set();
    function clearTimeslotUrgencyNote() {
      if (!timeslotSection) return;
      const existingNote = timeslotSection.querySelector('.hc-timeslot-urgency');
      if (existingNote) existingNote.remove();
    }
    function clearTimeslots() {
      if (timeslotWrap) timeslotWrap.innerHTML = '';
      if (timeslotSection) timeslotSection.style.display = 'none';
      if (timeInput) timeInput.value = '';
      clearTimeslotUrgencyNote();
    }
    function isTimeFullForCurrentProduct(dateYMD, slot) {
      if (isSlotFullOnDate(dateYMD, slot)) return true;
      if (isStandardSlotFullOnDate(dateYMD, slot)) return true;
      if (dashboardSlotClosedOn(preorderAvailabilityData(), dateYMD, slot)) return true;   // owner dashboard (2026-10-15)
      return false;
    }
    function getSlotsForDate(date) {
      const dateYMD = formatYMD(date);
      const day = date.getDay();
      if (PICKUP_SLOT_DISPLAY_BY_DATE[dateYMD]) return PICKUP_SLOT_DISPLAY_BY_DATE[dateYMD].slice();
      return (day === 5 || day === 6) ? TIMESLOTS.weekend.slice() : TIMESLOTS.weekday.slice();
    }
    function renderTimeslots(date) {
      if (!timeslotWrap || !timeslotSection) return;
      const dateYMD = formatYMD(date);
      let slots = getSlotsForDate(date);
      slots = filterSlotsForAssorted(slots, date);
      if (timeInput) timeInput.value = '';
      timeslotSection.style.display = 'block';
      timeslotWrap.innerHTML = slots.map(function(slot) {
        const full = isTimeFullForCurrentProduct(dateYMD, slot);
        const cls = 'timeslot-btn' + (full ? ' timeslot-btn--full' : '');
        const disabledAttr = full ? ' disabled aria-disabled="true"' : '';
        return '<button type="button" class="' + cls + '" data-time="' + slot + '"' + disabledAttr + '>' +
          '<span class="timeslot-time">' + slot + '</span>' +
          (full ? ' <span class="timeslot-full-label">Full</span>' : '') +
          '</button>';
      }).join('');
      clearTimeslotUrgencyNote();
      const hasVisibleFullSlot = slots.some(function(slot) { return isTimeFullForCurrentProduct(dateYMD, slot); });
      const allFull = slots.length > 0 && slots.every(function(slot) { return isTimeFullForCurrentProduct(dateYMD, slot); });
      if (hasVisibleFullSlot) {
        const note = document.createElement('p');
        note.className = 'hc-timeslot-urgency';
        note.textContent = allFull ? NO_PICKUP_TIMES_MSG : 'Some pickup times are already full. Please choose another available pickup time.';
        timeslotWrap.insertAdjacentElement('afterend', note);
      }
    }
    // Re-render the slots for the selected date after the owner record arrives / is re-confirmed. A still-valid selection
    // is restored exactly; a selection that just became unavailable is CLEARED and the customer is told — never swapped
    // to another time. Returns true when the previous selection was lost.
    function refreshTimeslotsKeepingSelection(date) {
      if (!timeslotWrap || !timeInput) return false;
      var prev = timeInput.value;
      renderTimeslots(date);
      if (!prev) return false;
      var btn = timeslotWrap.querySelector('[data-time="' + prev + '"]');
      if (btn && !btn.disabled && !btn.classList.contains('timeslot-btn--full')) {
        timeslotWrap.querySelectorAll('.timeslot-btn').forEach(function(b) { b.classList.remove('timeslot-btn--active'); });
        btn.classList.add('timeslot-btn--active');
        timeInput.value = prev;
        return false;
      }
      timeInput.value = '';
      clearTimeslotUrgencyNote();
      var lost = document.createElement('p');
      lost.className = 'hc-timeslot-urgency';
      lost.textContent = 'Your selected pickup time (' + prev + ') is no longer available. Please choose another pickup time.';
      timeslotWrap.insertAdjacentElement('afterend', lost);
      return true;
    }
    if (timeslotWrap && !timeslotWrap.dataset.bound) {
      timeslotWrap.addEventListener('click', function(e) {
        const btn = e.target.closest('.timeslot-btn');
        if (!btn) return;
        if (btn.disabled || btn.classList.contains('timeslot-btn--full')) return;
        timeslotWrap.querySelectorAll('.timeslot-btn').forEach(function(b) { b.classList.remove('timeslot-btn--active'); });
        btn.classList.add('timeslot-btn--active');
        if (timeInput) timeInput.value = btn.dataset.time;
      });
      timeslotWrap.dataset.bound = 'true';
    }
    const cal = Object.create(window.HaruCalendar);
    cal.onSelect = function(date) {
      if (dateInput) dateInput.value = formatDate(date);
      if (dateDisplay) dateDisplay.textContent = formatDate(date);
      renderTimeslots(date);
      applyLetteringDateRule(date); // Aug-22 lettering rule: disable on select / restore on change-away
      applySizeDateRule(date);      // Sep-26 7-inch-only rule: disable 6" on select / restore on change-away
    };
    cal.onClear = function() {
      if (dateInput) dateInput.value = '';
      applySizeDateRule(null);
      if (dateDisplay) dateDisplay.textContent = '';
      clearTimeslots();
    };
    if (!isSameDay) { cal.init('#cal-wrap', { blackoutDates: blackoutDates, forceOpenDates: productForceOpenDates }); }

    /* ── Edit mode: pre-fill from URL params ─────────────────────────────── */
    if (!isSameDay) {
      var editParams = new URLSearchParams(window.location.search);
      var editDateStr  = editParams.get('edit_date');
      var editTimeStr  = editParams.get('edit_time');
      var editWriting  = editParams.get('edit_writing') || '';
      var editText     = editParams.get('edit_text') || '';
      var isEditMode   = !!editDateStr || !!editWriting;

      if (isEditMode) {
        // Change button label
        var addBtn = form.querySelector('.add-to-cart-btn');
        if (addBtn) { addBtn.textContent = 'Update Cart'; }

        // Pre-fill writing toggle
        if (writingToggle && editWriting.toLowerCase().indexOf('yes') !== -1) {
          writingToggle.checked = true;
          writingEnabled = true;
          if (writingField) writingField.style.display = 'block';
          if (writingInput) {
            writingInput.value = editText;
            var charCounter = document.getElementById('char-count');
            if (charCounter) charCounter.textContent = editText.length;
          }
          updateVariant();
          updatePrice();
        }

        // Pre-select calendar date
        if (editDateStr) {
          var preDate = parseEditDateString(editDateStr);
          if (preDate && isSelectable(preDate, blackoutDates, productForceOpenDates)) {
            cal.viewYear = preDate.getFullYear();
            cal.viewMonth = preDate.getMonth();
            cal.selectedDate = preDate;
            cal.render();
            cal.onSelect(preDate); // sets dateInput + renders timeslots
            // Dispatch change event so CYO block's fetchAvailability() also fires
            if (dateInput) dateInput.dispatchEvent(new Event('change'));

            // Pre-select time after timeslots have rendered
            if (editTimeStr) {
              setTimeout(function () {
                if (!timeslotWrap) return;
                var timeBtn = timeslotWrap.querySelector('[data-time="' + editTimeStr + '"]');
                if (timeBtn && !timeBtn.disabled && !timeBtn.classList.contains('timeslot-btn--full')) {
                  timeslotWrap.querySelectorAll('.timeslot-btn').forEach(function(b) {
                    b.classList.remove('timeslot-btn--active');
                  });
                  timeBtn.classList.add('timeslot-btn--active');
                  if (timeInput) timeInput.value = editTimeStr;
                }
              }, 0);
            }
          }
        }
      }
    }
    /* ── End edit mode ───────────────────────────────────────────────────── */

    /* ── Owner dashboard: Preorder Availability Controls (pre-order products ONLY; see PREORDER AVAILABILITY above) ──
       One shared fetch per page load. On success: lettering-closed dates join LETTERING_DISABLED_DATES, and dates on
       which THIS cake's handle is closed join PAGE_PREORDER_CLOSED_DATES (read by currentPickupRules() → isSelectable(),
       i.e. the calendar cells, the add-to-cart guard, the live re-check and edit-mode prefill all see them). The calendar
       is re-rendered; an already selected date that just closed is cleared with the standard notice. On failure nothing
       changes (fail-open). Same Day pages never reach this block. */
    if (!isSameDay) {
      PAGE_PREORDER_CLOSED_DATES = new Set();
      var pageHandle = String(form.dataset.productHandle || '').toLowerCase();
      fetchPreorderAvailability().then(function(avail) {
        if (!avail || !avail.ok) return;
        Object.keys(avail.overrides).forEach(function(ymd) {
          if (avail.overrides[ymd].letteringDisabled) { DASHBOARD_LETTERING_DATES.add(ymd); LETTERING_DISABLED_DATES.add(ymd); }
        });
        preorderClosedDatesForHandle(avail, pageHandle).forEach(function(ymd) { PAGE_PREORDER_CLOSED_DATES.add(ymd); });
        var picked = cal.selectedDate;   // read BEFORE re-rendering: render() silently drops a now-unselectable date
        if (picked && PAGE_PREORDER_CLOSED_DATES.has(formatYMD(picked))) { showPickupDateUnavailable(false, pickupDateClosedMessage(formatYMD(picked))); return; }   // clears + re-renders + notice
        if (cal.wrap) cal.render();
        if (picked) applyLetteringDateRule(picked);
        if (picked) refreshTimeslotsKeepingSelection(picked);   // owner-closed pickup times for the already-selected date
      });
    }

    const thumbs  = document.querySelectorAll('.thumb-btn');
    const mainImg = document.getElementById('main-product-img');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('thumb-btn--active'); });
        thumb.classList.add('thumb-btn--active');
        if (mainImg) mainImg.src = thumb.dataset.src;
      });
    });
    function getSelectedPickupDate() {
      if (cal.selectedDate) return cal.selectedDate;
      if (dateInput && dateInput.value) return parseDisplayDate(dateInput.value);
      return null;
    }
    /* ── Live pickup-date re-check (see LIVE PICKUP RULES above) ─────────────────────────────────── */
    var liveCheck = { ymd: null, at: 0, busy: false };
    function liveCheckPassedFor(ymd) { return liveCheck.ymd === ymd && (Date.now() - liveCheck.at) < 20000; } // covers the add-on modal resume
    // Message for a closed pickup date on THIS product: the dashboard's explicit reason when there is one, else the generic text.
    function pickupDateClosedMessage(ymd) {
      return preorderClosedMessage(ymd ? preorderClosedReason(preorderAvailabilityData(), String(form.dataset.productHandle || '').toLowerCase(), ymd) : null);
    }
    function showPickupDateUnavailable(reloadAfter, message) {
      var text = message || PICKUP_DATE_UNAVAILABLE_MSG;
      var err = document.getElementById('pickup-date-error');
      if (err) { err.textContent = text; err.style.display = 'block'; }
      else { alert(text); }
      // clear the stale selection so the customer must pick again from the (re-rendered) calendar
      cal.selectedDate = null;
      if (dateInput) dateInput.value = '';
      if (dateDisplay) dateDisplay.textContent = '';
      clearTimeslots();
      if (reloadAfter) { setTimeout(function() { window.location.reload(); }, 1800); } // stale tab → reload gets the current calendar
      else if (cal.wrap) { cal.render(); }
    }
    function runLivePickupCheck(selectedDate) {
      if (liveCheck.busy) return;
      liveCheck.busy = true;
      var btn = form.querySelector('.add-to-cart-btn');
      var origLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Checking availability…'; }
      var ymd = formatYMD(selectedDate);
      var finish = function() { liveCheck.busy = false; if (btn) { btn.disabled = false; btn.textContent = origLabel; } };
      // Pickup-time confirmation (2026-10-15): the owner may have closed the selected slot after this page loaded. The
      // dashboard record is re-read FRESH (shared promise dropped + cache-busted) in parallel with the live rules; a
      // slot closed by the owner → blocked with the slots re-rendered and the customer asked to pick another time; a
      // record that cannot be confirmed LIVE (board down / timeout / malformed) → the pre-order is HELD with a retry
      // message (fail-closed; see the deploy notes). The selected time is never changed silently.
      var availP = fetchPreorderAvailabilityFresh();
      var proceed = function() {
        liveCheck.ymd = ymd; liveCheck.at = Date.now();
        finish();
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
        else { var sb = form.querySelector('button[type="submit"], input[type="submit"]'); if (sb) sb.click(); }
      };
      var confirmPickupTime = function() {
        return availP.then(function(avail) {
          if (!avail || avail.source !== 'live') { finish(); alert(PICKUP_TIME_UNCONFIRMED_MSG); return false; }
          var slot = timeInput ? timeInput.value : '';
          if (slot && dashboardSlotClosedOn(avail, ymd, slot)) { finish(); refreshTimeslotsKeepingSelection(selectedDate); alert(PICKUP_TIME_CLOSED_MSG); return false; }
          return true;
        });
      };
      fetchLivePickupRules(window.location.pathname + window.location.search).then(function(live) {
        var stillOpen = isSelectable(selectedDate, live.blackout, live.rules.forceOpen, live.rules);
        if (!stillOpen) { finish(); showPickupDateUnavailable(live.stale); return; }
        if (live.blackout && cal) { cal.blackoutDates = live.blackout; blackoutDates = live.blackout; }
        confirmPickupTime().then(function(ok) { if (ok) proceed(); });
      }).catch(function(err) {
        if (err && /rules unreadable/.test(String(err.message))) { finish(); showPickupDateUnavailable(true); return; } // stale tab whose new rules we cannot read → reload = current rules
        // Theme rules unreachable (offline / blocked): the in-page date check above already passed; the pickup-time
        // confirmation below still decides (it needs a LIVE dashboard answer) — the cart page re-checks before checkout.
        confirmPickupTime().then(function(ok) { if (ok) proceed(); });
      });
    }
    function tryAddCandleViaAjax(e, form) {
      var candleCards = document.querySelectorAll('.candle-card[data-variant-id]');
      var candleItems = [];
      for (var i = 0; i < candleCards.length; i++) {
        var card = candleCards[i];
        var qtyEl = card.querySelector('.candle-card__qtyval');
        if (!qtyEl) continue;
        var qty = parseInt(qtyEl.getAttribute('data-qty') || '0', 10);
        if (qty <= 0) continue;
        candleItems.push({ id: card.getAttribute('data-variant-id'), quantity: qty });
      }
      // Optional cake add-ons (Insulated Cake Bag, Cake Serving Set): real products added
      // as SEPARATE line items (qty 1 each) in this same atomic /cart/add.js request.
      var addonCards = document.querySelectorAll('.cake-addon-card[data-variant-id]');
      var addonItems = [];
      for (var a = 0; a < addonCards.length; a++) {
        var addonChk = addonCards[a].querySelector('.cake-addon-check');
        if (addonChk && addonChk.checked) {
          addonItems.push({ id: addonCards[a].getAttribute('data-variant-id'), quantity: 1 });
        }
      }
      if (!candleItems.length && !addonItems.length) return false;
      e.preventDefault();
      var fd = new FormData(form);
      var cakeVariantId = fd.get('id');
      var cakeQty = parseInt(fd.get('quantity') || '1', 10);
      var cakeProps = {};
      fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) cakeProps[m[1]] = v; });
      var btn = form.querySelector('.add-to-cart-btn');
      var origLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var items = [{ id: cakeVariantId, quantity: cakeQty, properties: cakeProps }].concat(candleItems).concat(addonItems);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (d) { throw new Error(d.description || d.message || 'Add to cart failed'); });
      })
      .then(function () { window.location.href = '/cart'; })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = origLabel; }
        alert('Add to cart failed: ' + err.message + '\nOne of the candles may be out of stock. Adjust quantities and try again.');
      });
      return true;
    }

    /* ── Complete-Your-Cake reminder modal (last-chance add-on upsell) ───────────
       UI-only layer over the EXISTING inline .cake-addon-card checkboxes. It never
       adds to cart itself: "Add Selected" just unions the inline checkboxes, then
       resumes the existing form submit so tryAddCandleViaAjax adds everything in the
       same /cart/add.js. A one-time bypass flag prevents the modal from re-opening
       on the resumed submit. Renders only when Liquid output #cake-addon-modal. */
    var addonModalBypass = false;
    function getAddonModal() { return document.getElementById('cake-addon-modal'); }
    function inlineAddonCheckFor(vid) {
      var card = document.querySelector('.cake-addon-card[data-variant-id="' + vid + '"]');
      return card ? card.querySelector('.cake-addon-check') : null;
    }
    function addonModalHasUnselected(modal) {
      var rows = modal.querySelectorAll('.cake-addon-modal-card[data-variant-id]');
      for (var i = 0; i < rows.length; i++) {
        var mrow = rows[i].querySelector('.cake-addon-modal-check');
        if (mrow && mrow.disabled) continue; // skip an add-on disabled by a date rule (Insulated Bag sold-out today)
        var inline = inlineAddonCheckFor(rows[i].getAttribute('data-variant-id'));
        if (inline && !inline.checked) return true; // at least one available add-on not yet selected
      }
      return false;
    }
    function onAddonModalKeydown(e) { if (e.key === 'Escape' || e.keyCode === 27) dismissAddonModal(); }
    function openAddonModal(modal) {
      var rows = modal.querySelectorAll('.cake-addon-modal-card[data-variant-id]');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var inline = inlineAddonCheckFor(row.getAttribute('data-variant-id'));
        var already = !!(inline && inline.checked);
        var mchk = row.querySelector('.cake-addon-modal-check');
        if (mchk) { mchk.checked = already; mchk.disabled = already; } // already-selected: shown checked + locked
        var badge = row.querySelector('.cake-addon-modal-selected');
        if (badge) badge.style.display = already ? '' : 'none';
        row.classList.toggle('is-preselected', already);
      }
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onAddonModalKeydown);
    }
    function closeAddonModalUI() {
      var modal = getAddonModal();
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onAddonModalKeydown);
    }
    function resumeAddonSubmit() {
      addonModalBypass = true; // consumed on the next submit pass
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
      else { var sb = form.querySelector('button[type="submit"], input[type="submit"]'); if (sb) sb.click(); }
    }
    function commitAddonModal() {
      var modal = getAddonModal();
      if (modal) {
        var rows = modal.querySelectorAll('.cake-addon-modal-card[data-variant-id]');
        for (var i = 0; i < rows.length; i++) {
          var mchk = rows[i].querySelector('.cake-addon-modal-check');
          if (mchk && mchk.checked) { // union only — never deselect an already-selected inline add-on
            var inline = inlineAddonCheckFor(rows[i].getAttribute('data-variant-id'));
            if (inline && !inline.checked) inline.checked = true;
          }
        }
      }
      closeAddonModalUI();
      resumeAddonSubmit();
    }
    function dismissAddonModal() { // "No thanks" / X / Escape / overlay — discard modal-only picks, keep inline as-is
      closeAddonModalUI();
      resumeAddonSubmit();
    }
    // Returns true if it intercepted (showed the modal); the caller must then return.
    function maybeShowAddonUpsell(e) {
      if (addonModalBypass) { addonModalBypass = false; return false; } // one-time bypass: let this submit through
      var modal = getAddonModal();
      if (!modal) return false;                       // product not eligible (Liquid didn't render it)
      if (!addonModalHasUnselected(modal)) return false; // Case 4: everything already selected → no modal
      e.preventDefault();
      openAddonModal(modal);
      return true;
    }
    (function wireAddonModal() {
      var modal = getAddonModal();
      if (!modal) return;
      var addBtn = modal.querySelector('.cake-addon-modal-add');
      var noBtn = modal.querySelector('.cake-addon-modal-dismiss');
      var xBtn = modal.querySelector('.cake-addon-modal-close');
      if (addBtn) addBtn.addEventListener('click', commitAddonModal);
      if (noBtn) noBtn.addEventListener('click', dismissAddonModal);
      if (xBtn) xBtn.addEventListener('click', dismissAddonModal);
      modal.addEventListener('click', function (e) {
        if (e.target === modal || (e.target.classList && e.target.classList.contains('cake-addon-modal__overlay'))) dismissAddonModal();
      });
    })();

    // Same-day lettering fresh check: a tab opened before the owner closed same-day lettering (or before 2 PM) must not
    // add lettering from stale state. Pass 1 stops the submit, re-reads the CURRENT dashboard record (fresh fetch, same
    // fallback chain) and re-submits only if lettering is still allowed; a closed answer sanitizes the lettering state
    // (No variant / price / flag) and tells the customer. Skipped when no lettering is requested (no extra request).
    var sameDayLetteringCheck = { at: 0, busy: false };
    // "Requested" mirrors what actually produces lettering on the order: the toggle (Yes variant / flag) or writingEnabled
    // (Board Message). Leftover text with the toggle OFF is not a request — the order goes out without lettering anyway.
    function sameDayLetteringRequested() {
      return !!((writingToggle && writingToggle.checked) || writingEnabled);
    }
    function sameDayLetteringCheckPassed() { return (Date.now() - sameDayLetteringCheck.at) < 20000; }
    function runSameDayLetteringCheck() {
      if (sameDayLetteringCheck.busy) return;
      sameDayLetteringCheck.busy = true;
      var btn = form.querySelector('.add-to-cart-btn');
      var origLabel = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Checking availability…'; }
      var finish = function() { sameDayLetteringCheck.busy = false; if (btn) { btn.disabled = false; btn.textContent = origLabel; } };
      fetchPreorderAvailabilityFresh().then(function(avail) {
        applySameDayDashboardResult(avail);
        finish();
        if (isSameDayWritingDisabledToday() || isAfterLetteringCutoff()) {
          normalizeLetteringOff(); applySameDayLetteringCutoff();
          alert(SAME_DAY_LETTERING_CLOSED_MSG + ' Your cake can still be ordered without lettering.');
          return;
        }
        // Policy: NEW same-day lettering needs a LIVE confirmation. A failed / timed-out / malformed live answer (the
        // chain fell back to the snapshot, LKG or nothing) never approves lettering on potentially stale data: no
        // submit, lettering left exactly as the customer set it (nothing removed silently), clear message. The customer
        // can retry, or switch lettering off and order the cake (no check needed without lettering).
        if (!avail || avail.source !== 'live') { alert(SAME_DAY_LETTERING_UNCONFIRMED_MSG); return; }
        sameDayLetteringCheck.at = Date.now();
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(); }
        else { var sb = form.querySelector('button[type="submit"], input[type="submit"]'); if (sb) sb.click(); }
      });
    }
    form.addEventListener('submit', function(e) {
      if (isSameDayProduct(form)) {
        // Aug-22 backstop: if a same-day cake is ordered on 2026-08-22, sanitize any stale
        // lettering state (no alert, order still proceeds) before the Board Message is set below.
        if (LETTERING_DISABLED_DATES.has(getTodayYMDInLosAngeles()) || isSameDayWritingDisabledToday()) { normalizeLetteringOff(); }
        if (sameDayLetteringRequested() && !sameDayLetteringCheckPassed()) { e.preventDefault(); runSameDayLetteringCheck(); return; }
        if (insulatedBagBlockedToday) { normalizeInsulatedBagOff(); } // Sep-4: never add the bag for same-day pickup today
        // Board lettering validation: require text if toggle is on, before 2 PM cutoff
        if (!isAfterLetteringCutoff() && writingEnabled && writingInput && !writingInput.value.trim()) {
          e.preventDefault(); alert('Please enter your cake board message before adding to cart.'); return;
        }
        // Persist board message as line item property
        if (writingEnabled && writingInput && writingInput.value.trim()) {
          setLineItemProperty(form, 'Board Message', writingInput.value.trim());
        }
        if (maybeShowAddonUpsell(e)) return; // last-chance add-on reminder (after validation, before cart)
        prepareSameDayPickup(form); tryAddCandleViaAjax(e, form); return;
      }
      const selectedDate = getSelectedPickupDate();
      if (!selectedDate) { e.preventDefault(); alert('Please select a pickup date.'); return; }
      if (!isSelectable(selectedDate, blackoutDates, productForceOpenDates)) { e.preventDefault(); showPickupDateUnavailable(false, pickupDateClosedMessage(formatYMD(selectedDate))); return; }
      if (!timeInput || !timeInput.value) { e.preventDefault(); alert('Please select a pickup time.'); return; }
      // Live re-check against the CURRENT rules on the server (a tab opened hours ago still runs the old
      // constants). The first pass stops the submit, fetches, and re-submits only if the date is still open.
      if (!liveCheckPassedFor(formatYMD(selectedDate))) { e.preventDefault(); runLivePickupCheck(selectedDate); return; }
      const selectedYMD = formatYMD(selectedDate);
      // Lettering-date backstop (Aug-22 / TEMPORARY Sep 25-26): independent of the visible toggle. If ANY stale
      // lettering state is still present for a blocked pickup date (toggle, +$10 flag, or text), sanitize it and
      // stop THIS submit with the notice so the customer sees the change; the next click proceeds without lettering.
      if (LETTERING_DISABLED_DATES.has(selectedYMD)) {
        var staleFlag = document.getElementById('writing-flag');
        var staleLettering = !!((writingToggle && writingToggle.checked) || writingEnabled ||
          (writingInput && writingInput.value.trim()) || (staleFlag && /yes/i.test(staleFlag.value || '')));
        normalizeLetteringOff();
        if (staleLettering) { e.preventDefault(); applyLetteringDateRule(selectedDate); alert(letteringDateMessage(selectedYMD)); return; }
      }
      if (selectedYMD === '2026-05-26' && !isAssortedCakeProduct() && selectedSize && selectedSize.indexOf('6"') !== -1) { e.preventDefault(); alert('6-inch cakes are sold out for this pickup date. Please select 7-inch.'); return; }
      if (SEVEN_INCH_ONLY_DATES.indexOf(selectedYMD) !== -1 && !isAssortedCakeProduct() && selectedSize && selectedSize.indexOf('6"') !== -1) { e.preventDefault(); applySizeDateRule(selectedDate); alert(SEVEN_INCH_ONLY_MSG); return; }
      // Next-day = 7" only backstop: a stale/forced non-7" size (variable OR hidden input) for a next-day pickup never reaches the cart.
      if (!isAssortedCakeProduct() && sizeCards.length && isNextDayPickupYMD(selectedYMD)) {
        var staleSize = selectedSize || (sizeInput && sizeInput.value) || '';
        if (staleSize && sizeInchOf(staleSize) !== '7') { e.preventDefault(); applySizeDateRule(selectedDate); alert(NEXT_DAY_SIZE_MSG + ' Please select 7".'); return; }
      }
      if (isTimeFullForCurrentProduct(selectedYMD, timeInput.value)) { e.preventDefault(); alert('This pickup time is now full. Please select a different time.'); return; }
      if (isAssortedCakeProduct()) {
        if (isAssortedSlotBlockedOnDate(selectedYMD, timeInput.value)) { e.preventDefault(); renderTimeslots(selectedDate); alert(ASSORTED_BLOCKED_SLOT_MSG); return; }
        const minMinutes = assortedMinMinutesForDate(selectedDate);
        if (timeToMinutes(timeInput.value) < minMinutes) {
          e.preventDefault();
          alert(selectedDate.getDay() === 6
            ? 'Assorted Cake orders on Saturday require a pickup time of 1:00 PM or later. Please select a valid time.'
            : 'Assorted Cake orders require a pickup time of 12:00 PM or later. Please select a valid time.');
          return;
        }
      }
      if (!selectedSize && !isAssortedCakeProduct()) { e.preventDefault(); alert('Please select a cake size.'); return; }
      if (maybeShowAddonUpsell(e)) return; // last-chance add-on reminder (after validation, before cart)
      tryAddCandleViaAjax(e, form);
    });
    updatePrice();
  }

  /* ─────────────────────────────────────────
     HEADER / MOBILE NAV
     ───────────────────────────────────────── */
  function initHeader() {
    var toggle = document.querySelector('.mobile-nav-toggle');
    var nav    = document.querySelector('.header-nav');
    var siteHeader = document.querySelector('.site-header');
    if (!toggle || !nav) return;

    function openNav() {
      // Anchor nav to actual header bottom (accounts for announcement bar height)
      if (siteHeader) {
        nav.style.top = Math.round(siteHeader.getBoundingClientRect().bottom) + 'px';
      }
      nav.classList.add('header-nav--open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function closeNav() {
      nav.classList.remove('header-nav--open');
      nav.style.top = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function() {
      if (nav.classList.contains('header-nav--open')) { closeNav(); } else { openNav(); }
    });
    // Close mobile nav overlay when any nav link is tapped
    nav.querySelectorAll('.header-nav__link').forEach(function(link) {
      link.addEventListener('click', function() { closeNav(); });
    });
  }

  /* ─────────────────────────────────────────
     CART PAGE - quantity controls
     ───────────────────────────────────────── */
  function initCartPage() {
    initCartPickupGuard();
    document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const row = btn.closest('[data-cart-item]');
        if (!row) return;
        const input = row.querySelector('.cart-qty-input');
        if (!input) return;
        const delta = btn.classList.contains('cart-qty-plus') ? 1 : -1;
        const val = Math.max(0, parseInt(input.value || 1, 10) + delta);
        input.value = val;
        if (input.closest('form')) { input.closest('form').submit(); }
      });
    });
  }

  /* ─────────────────────────────────────────
     CART PAGE - pickup date must still be open under the CURRENT rules (stale-cart protection)
     ─────────────────────────────────────────
     A cake added while a date was open must not reach checkout after that date was closed (force-open date
     removed, blackout added, lead time passed). On load and again on every checkout click: read /cart.js,
     fetch each cake's product page for its current blackout list + the current theme.js rules, and evaluate
     each stored "Pickup Date" with the same isSelectable(). Invalid → message on the item + checkout blocked.
     Candles / add-ons / accessories (no Pickup Date) are never affected. */
  function initCartPickupGuard() {
    const CHECKOUT_SEL = 'a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"], form[action="/checkout"] [type="submit"]';
    if (!document.querySelector(CHECKOUT_SEL) && !document.querySelector('[data-cart-item]')) return; // not the cart page
    var guard = { state: 'unknown', invalid: [], bypass: false, busy: false, promise: null };
    const MSG_ID = 'cart-pickup-date-msg';
    function setCheckoutDisabled(disabled) {
      document.querySelectorAll(CHECKOUT_SEL).forEach(function(el) {
        el.classList.toggle('checkout-btn--blocked', disabled);
        el.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        el.style.opacity = disabled ? '0.5' : '';
        el.style.pointerEvents = ''; // keep clickable so the click handler can re-check / explain
      });
    }
    function renderResult(invalid) {
      document.querySelectorAll('.cart-item__date-unavailable').forEach(function(n) { n.remove(); });
      var top = document.getElementById(MSG_ID); if (top) top.remove();
      invalid.forEach(function(item) {
        var row = document.querySelector('[data-cart-item="' + item.key + '"] .cart-item__details');
        if (!row) return;
        var p = document.createElement('p');
        p.className = 'cart-item__date-unavailable';
        p.style.cssText = 'margin:8px 0 0;padding:8px 12px;border-radius:6px;background:#fdf4f4;border:1px solid #f0d0d0;color:#8e2525;font-size:13px;line-height:1.5;';
        p.textContent = item.reason === 'preorders-closed' ? PREORDERS_CLOSED_CART_MSG : item.reason === 'assorted-closed' ? ASSORTED_CLOSED_CART_MSG : item.reason === 'preorder-closed' ? PREORDER_CLOSED_CART_MSG : item.reason === 'same-day-lettering' ? SAME_DAY_LETTERING_CART_MSG : item.reason === 'pickup-time-closed' ? PICKUP_TIME_CLOSED_CART_MSG : (PICKUP_DATE_UNAVAILABLE_MSG + ' Please remove this cake or tap Edit to choose a new pickup date.');
        row.appendChild(p);
      });
      if (invalid.length) {
        var first = document.querySelector(CHECKOUT_SEL);
        if (first && first.parentNode) {
          var m = document.createElement('p');
          m.id = MSG_ID;
          m.style.cssText = 'margin:0 0 10px;padding:10px 12px;border-radius:6px;background:#fdf4f4;border:1px solid #f0d0d0;color:#8e2525;font-size:13px;line-height:1.5;';
          m.textContent = (invalid.every(function(x) { return x.reason === 'same-day-lettering'; }) ? SAME_DAY_LETTERING_CLOSED_MSG : invalid.every(function(x) { return x.reason === 'pickup-time-closed'; }) ? 'A selected pickup time is no longer available.' : PICKUP_DATE_UNAVAILABLE_MSG) + ' Please update the highlighted cake before checking out.';
          first.parentNode.insertBefore(m, first);
        }
      }
      setCheckoutDisabled(invalid.length > 0);
    }
    // Resolve → { ok, invalid:[{key,title,reason}] }. Never resolves "ok" unless every cake was actually evaluated
    // against server-current rules (fail closed on network/parse errors).
    function check(fresh) {
      if (guard.promise) return guard.promise;
      guard.busy = true;
      guard.promise = fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function(r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .then(function(cart) {
          var cakes = (cart.items || []).filter(function(it) { return it.properties && it.properties['Pickup Date']; });
          if (!cakes.length) return { ok: true, invalid: [] };
          var byUrl = {};
          cakes.forEach(function(it) { var u = String(it.url || '').split('?')[0]; if (u) byUrl[u] = byUrl[u] || fetchLivePickupRules(u); });
          var availP = fresh ? fetchPreorderAvailabilityFresh() : fetchPreorderAvailability();   // owner dashboard record (never rejects; fail-open); checkout click = fresh
          return Promise.all(cakes.map(function(it) {
            var u = String(it.url || '').split('?')[0];
            var p = byUrl[u] || Promise.reject(new Error('no product url'));
            return Promise.all([p, availP]).then(function(r) { var v = validateCartItemPickup(it, r[0], r[1]); return { key: it.key, title: it.product_title || it.title, ok: v.ok, reason: v.reason }; });
          })).then(function(rows) { var bad = rows.filter(function(x) { return !x.ok; }); return { ok: bad.length === 0, invalid: bad }; });
        })
        .then(function(res) { guard.state = res.ok ? 'ok' : 'blocked'; guard.invalid = res.invalid; renderResult(res.invalid); return res; })
        .catch(function() { guard.state = 'unknown'; return { ok: false, invalid: [], error: true }; })
        .then(function(res) { guard.busy = false; guard.promise = null; return res; });
      return guard.promise;
    }
    // Capture-phase (document) so it runs before the section's own checkout click handler.
    document.addEventListener('click', function(e) {
      var el = e.target && e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
      if (!el) return;
      if (guard.bypass) { guard.bypass = false; return; } // our own re-click after a passing check
      e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
      var origLabel = el.textContent;
      el.textContent = 'Checking pickup dates…';
      check(true).then(function(res) {
        el.textContent = origLabel;
        if (res.ok) { guard.bypass = true; el.click(); return; }             // lets the Note-for-Baker save + navigation run
        if (res.error) { alert('We could not confirm your pickup date right now. Please refresh the page and try again.'); return; }
        var m = document.getElementById(MSG_ID); if (m && m.scrollIntoView) m.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }, true);
    check(); // early feedback on page load (message on the cake + checkout dimmed)
  }

  /* ─────────────────────────────────────────
     ANNOUNCEMENT BAR auto-dismiss
     ───────────────────────────────────────── */
  function initAnnouncement() {
    const bar   = document.querySelector('.announcement-bar');
    const close = document.querySelector('.announcement-close');
    if (!bar || !close) return;
    close.addEventListener('click', function() { bar.style.display = 'none'; });
  }

  /* ─────────────────────────────────────────
     INIT
     ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    initProductPage();
    initCartPage();
    initAnnouncement();
  });

})();
